
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memoriam",
      function () {
        return require("private-next-pages/memoriam/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memoriam"])
      });
    }
  